import "./resource";
import { StripeContract } from "../../typings/payment";

class MonextContractService {
    public static $inject: string[] = [
        "$log",
        "$q",
        "monextContractResource"
    ];

    constructor(
        private $log: ng.ILogService,
        private $q: ng.IQService,
        private monextContractResource
    ) { }

    public create(id, type, providerInfos) {
        return this.monextContractResource()
            .create({id}, {
                type,
                provider_infos: providerInfos,
                options: {}
            })
            .$promise
            .then(({ data: contracts }: { data: StripeContract[] }) => {
                this.$log.info("Fetching contracts ok : ", contracts);
                return contracts;
            })
            .catch(error => {
                this.$log.error("Error while getting contracts organization", error);
                return this.$q.reject(error);
            });
    }

    public update(id, type, providerInfos) {
        return this.monextContractResource()
            .update({id}, {
                type,
                provider_infos: providerInfos,
                options: {}
            })
            .$promise
            .then(({ data: contract }: { data: StripeContract }) => {
                this.$log.info("Updating contract ok : ", contract);
                return contract;
            })
            .catch(error => {
                this.$log.error("Error while updating contract organization", error);
                return this.$q.reject(error);
            });
    }
}

angular
    .module("thor.core.monext-contract.service", [
        "thor.core.monext-contract.resource"
    ])
    .service("monextContractService", MonextContractService);
